// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".newsletter-signup__description{margin:var(--spacing-smaller) 0 0}.newsletter-signup__button.app-button{margin:var(--spacing-medium) 0 0}@media(max-width:1023px){.newsletter-signup__button.app-button{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
